<template>
    <div class="content">
        <a-spin :spinning="liveSpinning">
                    <a-table 
                    :rowKey="(record,index)=>{return index}"
                    :columns="columns"
                    :data-source="dataSource" 
                    bordered
                >
                    <template slot="TITTLE" slot-scope="text,record,index">
                        {{record.title}}(ISSN:{{record.issn}})
                    </template>
                    <template slot="NumBer" slot-scope="text,record,index">
                        <a-input-number style="width:60px;" id="inputNumber" v-model="record.NumBer" :min="1" :max="record.stock" placeholder="输入数量" />
                    </template>
                    
                    <template slot="addCar" slot-scope="text,record,index">
                        <a-button icon="check" @click="addCar(record.id,record.title,record.price,record.NumBer,record.stock)" style="background: #2caf7a;color:#fff;padding-bottom:5px;"></a-button>
                    </template>
            </a-table>
        </a-spin>
    </div>
</template>

<script>
export default{
    name:'Listleft',
    data:function(){
        return{
            columns: [
                {
                    align: 'center',
                    title: '序号',
                    width:61,
                    customRender: (text,record,index) => `${index+1}`
                }, 
                {
                    align: 'center',
                    title: '课程',
                    dataIndex: 'subjectCode',
                    customCell: () => {
                        return {
                            style: {
                            'text-align': 'left'
                            },
                        };
                    },
                },
                {
                    align: 'center',
                    title: '教材名称',
                    dataIndex: 'title',
                    scopedSlots: { customRender: 'TITTLE' },
                    customCell: () => {
                        return {
                            style: {
                            'text-align': 'left'
                            },
                        };
                    },
                },
                
                // {
                //     align: 'center',
                //     title: 'ISSN编码',
                //     dataIndex: 'issn'
                // }, 
                // {
                //     align: 'center',
                //     title: '库存',
                //     dataIndex: 'stock'
                // }, 
                {
                    align: 'center',
                    width:61,
                    title: '价格',
                    dataIndex: 'price'
                },
                {
                    align: 'center',
                    title: '数量',
                    dataIndex: 'NumBer',
                    scopedSlots: { customRender: 'NumBer' }

                },
                {
                    align: 'center',
                    title: '操作',
                    dataIndex: 'addCar',
                    scopedSlots: { customRender: 'addCar' }
                }
            ],
            dataSource: [],
            liveSpinning: true
        } 
    },

    created(){
       this.getOrderList()
    },

    methods:{
            //Order 列表数据
            getOrderList(){
                
                // console.log('调用成功')
                this.axios.get(`/biz/material/list`).then(res => {
                if (res.success) {
                    this.dataSource = res.result
                    this.dataSource.forEach(d=>{
                        d.NumBer = 1
                    })
                    this.liveSpinning = false
                }
            })
        },

        addCar(id,title,price,num,stock){
            if(num<stock){
                this.$store.commit('getReceiveData',{id:id,title:title,price:price,NumBer:num})
            }else{
                this.$message.warning('库存不足，请修改购买数量！')
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
.content{
    padding:10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/textbookOrder/ListLeft.vue